// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-lUHwa","register__button":"register__button-1ggrf","register__content":"register__content-1OyVc","register__label":"register__label-17TuS"};